<template>
  <div class="incoming">
    <div class="logo"></div>
    <el-form class="form" :model="form" :rules="rules" ref="form" label-width="100px">
      <h2>扫 码 进 件</h2>
      <el-form-item label="客户姓名" prop="name">
        <el-input type="text" v-model="form.name" placeholder="请输入客户姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码" prop="idCard">
        <el-input type="text" v-model="form.idCard" placeholder="请输入身份证号码"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input type="number" v-model.number="form.mobile" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="银行卡号" prop="bankNo">
        <el-input type="text" v-model="form.bankNo" placeholder="请输入银行卡号"></el-input>
      </el-form-item>
      <div class="tips">
        <span @click="agree = !agree" class="left">
          <i v-if="agree" class="el-icon-success checked"></i>
          <span v-else class="unChecked"></span>
          <span class="txt">阅读并同意</span>
        </span>
        <el-link href="https://res.mingweigz.com/yxph/信用授权书.docx" type="danger" class="book" @click.stop="">《信息授权书》</el-link>
      </div>
      <el-button class="button" type="primary" :loading="isLoading" @click="submit">提 交 预 审</el-button>
    </el-form>
  </div>
</template>

<script>
import './assets/css/incoming.css'
import {createOrder} from "@/api/sys/incoming/incoming";

export default {
  name: "incoming",
  data(){
    return {
      isLoading: false,
      form: {
        name: '',
        idCard: '',
        mobile: '',
        bankNo: '',
        publicizeCode: ''
      },
      agree: true,
      rules: {
        name: [{ required: true, message: '客户姓名不能为空', trigger: 'blur' }],
        idCard: [{ required: true, validator: (rule, value, callback) => {
            if ( value.trim() === '') {
              callback(new Error('身份证号码不能为空'))
            } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
              callback('身份证号码不正确')
            } else {
              callback()
            }
          }, trigger: 'blur' }],
        mobile: [{ required: true, validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('手机号码不能为空'))
            } else if (!/^(13|14|15|16|17|18|19)\d{9}$/.test(value)) {
              callback(new Error('手机号码格式不正确'))
            } else {
              callback()
            }
          }, trigger: 'blur' }],
        bankNo: [{ required: true, message: '银行卡号不能为空', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.form.publicizeCode = this.$route.query.code;
  },
  methods: {
    submit(){
      if (!this.agree) {
        this.$message.error("请阅读并同意《信息授权书》")
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid){
          this.isLoading = true
          createOrder(this.form).then(() => {
            this.$message.success("进件成功")
            this.isLoading = false
          }).catch(() => {
            this.isLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
